import { logger } from "../utils/utils";
import api from "./apis/api";

class SpiritService {
  createSpiritApi() {
    logger("SpiritService", "createSpiritApi");
    return api.spirit.createSpirit();
  }

  getSpiritListApi(spiritReq) {
    logger("SpiritService", "getSpiritListApi");
    return api.spirit.getSpiritList(spiritReq);
  }

  getSpiritByIdApi(spiritId) {
    logger("SpiritService", "getSpiritByIdApi");
    return api.spirit.getSpiritById(spiritId);
  }

  updateSpiritById(payload) {
    logger("SpiritService", "updateSpiritById");
    return api.spirit.updateSpiritById(payload?.spiritId, payload?.payload);
  }

  createSpiritLogsApi(payload) {
    logger("SpiritService", "createSpiritLogsApi");
    return api.spirit.createSpiritLogs(payload);
  }

  updateSpiritLogsApi(payload) {
    logger("SpiritService", "updateSpiritLogsApi");
    return api.spirit.updateSpiritLogs(payload?.spiritLogId, payload?.payload);
  }

  deleteSpiritLog(subLogId) {
    logger("SpiritService", "deleteSpiritLog");
    return api.spirit.deleteSpiritLog(subLogId);
  }

  getSpiritLogsListApi(payload) {
    logger("SpiritService", "getSpiritLogsListApi");
    return api.spirit.getSpiritLogsList(payload);
  }

  addWasteWaterData(payload) {
    logger("SpiritService", "addWasteWaterData");
    return api.spirit.addWasteWaterData(payload);
  }

  updateWasteWater(payload) {
    logger("SpiritService", "addWasteWaterData");
    return api.spirit.updateWasteWater(payload?.wasteWaterId, payload?.payload);
  }

  getWasteWaterList(payload) {
    logger("SpiritService", "updateWasteWater");
    return api.spirit.getWasteWaterList(payload);
  }

  deleteWasteWater(wasteWaterId) {
    logger("SpiritService", "deleteWasteWater");
    return api.spirit.deleteWasteWater(wasteWaterId);
  }

  sendToSpiritProcessApi(payload) {
    return api.spirit.sendToSpiritProcessApi(payload);
  }

  getEndOfRunCutApi(spiritProcessId) {
    logger("SpiritService", "getEndOfRunCutApi");
    return api.spirit.getEndOfRunCut(spiritProcessId);
  }

  saveEndOfRunCutApi(payload) {
    logger("SpiritService", "saveEndOfRunCutApi");
    return api.spirit.saveEndOfRunCut(payload);
  }

  getEndOfRunCutByIdApi(id) {
    logger("SpiritService", "getEndOfRunCutByIdApi");
    return api.spirit.getEndOfRunCutById(id);
  }

  updateEndOfRunCutApi(payload) {
    logger("SpiritService", "updateEndOfRunCutApi");
    return api.spirit.updateEndOfRunCut(payload.id, payload);
  }

  deleteEndOfRunCutApi(id) {
    logger("SpiritService", "deleteEndOfRunCutApi");
    return api.spirit.deleteEndOfRunCut(id);
  }
}


export default new SpiritService();
